module.exports = __webpack_public_path__ + "static/media/css-modules-logo-cropped.69501a12.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentations/state-of-styling/assets/css-modules-logo-cropped.png
// module id = 234
// module chunks = 0